import { types as t, getRoot } from 'mobx-state-tree';

import { sortByTitle } from '@utils/sort-by-title';
import { getTitleLanguage } from '@utils/translated-title';

import Department, {
  DepartmentTranslation,
  findTranslationForCurrentLanguage,
  findTranslationForLanguage,
} from './Department';
import Location from './Location';
import uiStore from './UIStore';

const CompanyNamePossessiveForm = t.model('CompanyNamePossessiveForm', {
  is: t.maybe(t.string),
  en: t.maybe(t.string),
});

export default t
  .model('Company', {
    name: t.string,
    companyName: t.string,
    companyNamePossessiveForms: t.maybeNull(CompanyNamePossessiveForm),
    defaultLanguage: t.string,
    logo: t.maybeNull(t.string),
    logoHeight: t.number,
    banner: t.maybeNull(t.string),
    url: t.string,
    isEnterprise: t.boolean,
    ssnValidation: t.boolean,
    categoryName: t.maybeNull(t.string),
    departmentLabels: t.maybeNull(t.array(DepartmentTranslation)),
    departments: t.array(Department),
    locations: t.array(Location),
    privacyPolicyUrl: t.maybeNull(t.string),
    gaTracker: t.maybeNull(t.string),
    languages: t.string,
  })
  .views((self) => ({
    get langs() {
      const appRoot = getRoot(self);
      let jobLangs = {};
      appRoot.jobStore.allJobs.forEach((job) => {
        job.languages.forEach((jl) => {
          jobLangs[jl.language] = true;
        });
      });
      let setCompanyLanguages = self.languages.split(',').map((key) => key.trim());
      Object.keys(jobLangs).forEach((key) => {
        if (!setCompanyLanguages.includes(key)) {
          setCompanyLanguages.push(key);
        }
      });
      return setCompanyLanguages;
    },
    get departmentHeading() {
      const label =
        findTranslationForCurrentLanguage(self.departmentLabels) ||
        findTranslationForLanguage(self.departmentLabels, self.defaultLanguage);
      return label?.title || self.categoryName || uiStore.t('department_title');
    },
    get selectableDepartments() {
      return sortByTitle(
        self.departments.map((department) => ({
          display: department.translatedName,
          value: String(department.id),
        })),
        ({ display }) => display,
        getTitleLanguage(
          self.departments.map(({ translations }) => translations),
          uiStore.language,
          self.defaultLanguage
        )
      );
    },
  }))
  .actions((self) => ({
    possessiveForm(language) {
      return self.companyNamePossessiveForms && self.companyNamePossessiveForms[language];
    },
  }));
